import Vue from "vue";
import './formatters'
export function insertDelimeters(v, n, x) {
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    // tslint:disable-next-line:no-bitwise
    return v.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}
export function formatPercent(p) {
    return p.toFixed(2) + '%';
}


Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export function getDates(startDate, stopDate) {
    var dateArray = new Array();
    var currentDate = new Date(startDate.setHours(0, 0, 0, 0));
    while (currentDate <= stopDate) {
        dateArray.push(new Date (currentDate));
        currentDate = new Date(currentDate.addDays(1).setHours(0, 0, 0, 0));
    }
    return dateArray;
}

Vue.filter('formatPrice', (v) => {
    if (isNaN(v)) { return ''; }
    const result = '$' + insertDelimeters(roundPrice(v), 2);
    return result;
});
Vue.filter('formatDecim', (v) => {
    const result = insertDelimeters(roundPrice(v), 2);
    return result;
});
export function roundPrice(num) {
    if (('' + num).indexOf('e') === -1) {
        return +(Math.round(parseFloat(num + 'e+' + 2)) + 'e-' + 2);
    } else {
        const arr = ('' + num).split('e');
        let sig = '';
        if (+arr[1] + 2 > 0) {
            sig = '+';
        }
        return +(Math.round(parseFloat(+arr[0] + 'e' + sig + (+arr[1] + 2))) + 'e-' + 2);
    }
}
Vue.filter('formatPercent', formatPercent);

export function getNextMonth(n) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const d = new Date();
    d.setMonth(new Date().getMonth() + n);
    return monthNames[d.getMonth()];
}

export function formatPrice(v) {


    if (isNaN(v)) {return ''; }
    const result = '$' + insertDelimeters(roundPrice(v), 2);
    return result;
}
